import { forwardRef } from "react";
import { Field, Label, Switch as HeadlessSwitch, SwitchProps } from "@headlessui/react";

import { cx } from "utils";


const Switch = forwardRef((
  {
    label,
    className,
    ...switchProps
  }: Omit<SwitchProps, "className"> & {
    label?: string | JSX.Element;
    className?: string;
  },
  ref
) => {
  return (
    <Field className={ className }>
      <Label>{ label }</Label>
      <HeadlessSwitch
        { ...switchProps }
      >
        {({ checked }) => (
          <div className={ cx(
            checked ? "bg-blue-600 dark:bg-brandPrimary-600" : "bg-gray-200 dark:bg-neutral-200",
            "h-6 w-11 inline-flex items-center rounded-full z-0 relative transition-colors"
          ) }>
            <span
              className={ cx(
                checked ? "translate-x-6" : "translate-x-1",
                "inline-block size-4 bg-white rounded-full transition-transform"
              ) }
            />
          </div>
        )}
      </HeadlessSwitch>
    </Field>
  );
});

export default Switch;
